import { Flex, Text } from "@chakra-ui/react";
import { Control, Controller } from "react-hook-form";
import { Field } from "@/components/ui/field";
import {
    chakraComponents,
    OptionBase,
    Select as ReactSelect
} from "chakra-react-select";
import { DonationsCodeListResponse } from "@/api/DonationsCodeListResponse";

export interface DonationCodeOption extends OptionBase {
    value: string; // code - 1MW001E
    label: string; // donation code type - Patenschaften
    group: string; // Afrika und Asien
    name: string; // Allgemeinden Projektfond
}

export const convert = (res: DonationsCodeListResponse): DonationCodeOption[] => {
    const typeId2Name = new Map(res.types.map(t => [t.id, t.name]));
    return res.results.map(code => ({
        value: code.code,
        label: typeId2Name.get(code.donationTypeId) ?? "",
        group: code.group,
        name: code.name,
    }));
}

const customItem = (item: DonationCodeOption) => (
    <Flex direction="column" align="flex-start">
        <Flex align="center">
            <Text fontWeight="bold">{item.value}</Text>
            <Text ml="2">{item.label}</Text>
        </Flex>
        {/* <Text fontSize="xs" color="gray.500">{item.group}</Text> */}
    </Flex>
);

const customOption = (props) => (
    <chakraComponents.Option {...props}>
        {customItem(props.data)}
    </chakraComponents.Option>
);

export const DonationCodeController = ({ control, codes: codes, name, label, readOnly, ...props }:
    { control: Control<any, any>, codes: DonationCodeOption[], name: string, label: string, readOnly: boolean, [key: string]: any }) => {
    const mandatory = props['required'] ?? false;
    // console.log(`rendering donation code controller ${name} with ${JSON.stringify(codes)} codes`)
    return (<Controller control={control} name={name}
        rules={{ required: mandatory && 'Kostenstelle auswählen', validate: (value) => !mandatory || !!value?.trim() || 'Kostenstelle auswählen' }}
        render={({ field: { value, name, onChange, onBlur, ref }, fieldState: { error, invalid } }) => (
            <Field id={name} label={label} required={mandatory} disabled={readOnly} invalid={invalid} errorText={error?.message}>
                <ReactSelect
                    isSearchable
                    isClearable={!mandatory}
                    placeholder='Kostenstelle'
                    required={mandatory}
                    isDisabled={readOnly}
                    autoFocus={false}
                    ref={ref}
                    name={name}
                    onBlur={onBlur}
                    options={codes}
                    onChange={val => onChange(val?.value ?? null)}
                    value={codes.find(c => c?.value === value)}
                    components={{ Option: customOption }}
                    formatOptionLabel={(option: DonationCodeOption) => customItem(option)}
                    getOptionLabel={(option: DonationCodeOption) => `${option.value} ${option.label} ${option.group}`}
                    getOptionValue={(option: DonationCodeOption) => option.value}
                />
            </Field>
        )} />);
}
